<template>
	<footer class="py-3 footer">
		<div class="container-fluid">
			<div class="row align-items-center justify-content-lg-between">
				<div class="mb-4 col-lg-6 mb-lg-0">
					<div class="text-sm text-center copyright text-muted" :class="'text-lg-start'">
						©
						{{ new Date().getFullYear() }}, criado com <i class="fa fa-heart"></i> pela <a href="#" class="font-weight-bold" target="_blank">Caramelo D&D</a>.
					</div>
				</div>
				<div class="col-lg-6">
					<ul class="nav nav-footer justify-content-center justify-content-lg-end">
						<li class="nav-item">
							<a href="#" class="nav-link text-muted" target="_blank">Caramelo</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'app-footer',
}
</script>
<style lang="scss">
.footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	max-width: 1660px;

	@media (max-width: 600px) {
		position: initial;
	}
}
</style>
